var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.399,
    height: 28.988,
    viewBox: "0 0 22.399 28.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1",
    transform: "translate(-68.669 -26.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1923",
    "data-name": "Group 1923",
    transform: "translate(68.669 26.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15973",
    "data-name": "Path 15973",
    d: "M87.378,41.853a6.6,6.6,0,0,1,2.97-5.522,6.319,6.319,0,0,0-5.031-2.871c-2.141-.23-4.18,1.329-5.267,1.329s-2.762-1.3-4.538-1.263a6.694,6.694,0,0,0-5.692,3.636c-2.426,4.435-.62,11.007,1.743,14.607,1.156,1.759,2.534,3.739,4.342,3.666,1.743-.073,2.4-1.188,4.507-1.188s2.7,1.188,4.542,1.151c1.874-.036,3.062-1.793,4.209-3.559a16.43,16.43,0,0,0,1.905-4.123A6.363,6.363,0,0,1,87.378,41.853ZM83.914,31.077a6.624,6.624,0,0,0,1.432-4.628,6.064,6.064,0,0,0-4.052,2.2,6.283,6.283,0,0,0-1.46,4.485A5.012,5.012,0,0,0,83.914,31.077Z",
    transform: "translate(-68.669 -26.449)",
    fill: "#acacac",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.861e7224c120708b00ab7f3e65ed9185.svg";
export { ForwardRef as ReactComponent };